import React from "react";

export default function DataManagerTruckPeriodControls({ period, onPeriodChange, disabled = false, children = null }) {
  return <div data-truck-period-controls className="mb-2 flex flex-wrap items-center gap-x-4 gap-y-2">
    <div role="group" aria-label="Vue des camions" className="flex gap-1">
      {[['day', 'Jour'], ['evening', 'Soir']].map(([value, label]) => <button key={value} type="button"
        aria-pressed={period === value} disabled={disabled} onClick={() => onPeriodChange(value)}
        className={`h-7 rounded-[4px] border px-3 text-xs font-semibold focus-visible:outline-accent disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-400 ${period === value
          ? "border-accent bg-accent text-white hover:border-accent-strong hover:bg-accent-strong"
          : "border-slate-300 bg-white text-slate-700 hover:border-slate-400 hover:bg-slate-50 hover:text-slate-900"}`}>
        {label}
      </button>)}
    </div>
    {children}
    <p className="m-0 text-xs text-slate-500">{period === "evening"
      ? "Activation et chauffeur par défaut du Soir. Le nom, le même que le Jour, se change dans la vue Jour ; les heures dans Chauffeurs."
      : "Coûts et adresse de départ communs au Jour et au Soir. La capacité et les débits d'une remorque se règlent dans Remorques ; ceux d'un dompeur, ici. Les heures dans Chauffeurs."}</p>
  </div>;
}
